import { client } from "../client";

export type AuthenticatedUser = {
  name: string;
};

export const getAuthenticatedUser = (): Promise<AuthenticatedUser> => {
  return client
    .get<AuthenticatedUser>("/oauth2client/user")
    .then((response) => response.data);
};
